const TRACKING_PREFIX = "learn-whats-next";
const addTrackingPrefix = (trackId) => {
  return `${TRACKING_PREFIX}-${trackId}`;
};
export {
  addTrackingPrefix
};
